module.exports = __webpack_public_path__ + "img/05.7914d4e2.png";